module.exports = __webpack_public_path__ + "static/media/slider3.d4cbd0ba.png";